import { useEffect, useState } from "react";
import Confetti from "react-confetti";
export default function ConfettiSection() {
  const [size, setSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    const update = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <Confetti
      width={size.width}
      height={size.height}
      numberOfPieces={3000}
      recycle={false}
      gravity={0.2}
      initialVelocityX={10}
      initialVelocityY={60}
      explosionPower={5}
    />
  );
}
